import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
// import "rxjs/add/operator/filter";
import { CsvUploadService } from "../../../services/csv-upload.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"]
})
export class UserComponent implements OnInit {
  searchresult = false;
  userEmail1 = false;
  invalidMail1 = false;
  userFNameNotAlphabet1 = false;
  userFNameExceedLength1 = false;
  userFNameMinLength1 = false;
  invalidMobile = false;
  searchlist: boolean = true;
  showList: boolean = false;
  nameExist: boolean = false;
  invalidMail = false;
  offSubmit = false;
  userFNameMinLength = false;
  userFNameExceedLength = false;
  userFNameNotAlphabet: boolean = false;

  userLNameMinLength = false;
  userLNameExceedLength = false;
  userLNameNotAlphabet: boolean = false;

  userMobileMinLength = false;
  userMobileExceedLength = false;
  userMobileNotNumber: boolean = false;

  userAddressMinLength = false;
  userAddressExceedLength = false;

  userEmail = false;

  viewTitle: string = "User View";
  serachTableInfo: any = [];
  insertDataTitle: string = "Data Successfully Created";
  screentitle: string = "User Management";
  actionmode: string = "Seacrh";
  parent_table = "mst_user";
  parent_table_ID = "USER_ID";
  child_table_ID = "PRODUCT_ID";

  childtables = ["mst_role"];
  APPROVAL_STATUS = "APPROVAL_STATUS";
  filters = ["ROLE_ID"];
  currencyArray: any = [];
  combo_details1: any = [];
  combo_details2: any = [];
  combo_details3: any = [];
  field_list: any = [];
  Parent_result_ID = "";

  checkbox_details: any = [];
  checkboxId: any = [];
  p: number = 1;

  USER_FIRSTNAME = "USER_FIRSTNAME";
  USER_LASTNAME = "USER_LASTNAME";
  USER_EMAIL = "USER_EMAIL";
  USER_PASSWORD = "USER_PASSWORD";
  USER_ADDRESS = "USER_ADDRESS";
  USER_MOBILE = "USER_MOBILE";
  ROLE_ID = "ROLE_ID";
  USER_STATUS ="USER_STATUS"
  loader: any = false;
  roleName;

  dbFields = [
    this.USER_FIRSTNAME,
    this.USER_LASTNAME,
    this.USER_EMAIL,
    this.USER_PASSWORD,
    this.USER_ADDRESS,
    this.USER_MOBILE,
    this.ROLE_ID,
    //
  ];
  dbField = [
    this.USER_FIRSTNAME,
    this.USER_LASTNAME,
    this.USER_EMAIL,
    this.USER_ADDRESS,
    this.USER_MOBILE,
    this.ROLE_ID,
  ];
  dbFieldsChild = [this.parent_table_ID, this.child_table_ID];
  searchitem = " ";
  searchColumn = " ";
  //user_screen_details: any = [];
  user_search_details: any = [];
  user_screen_details: any = [];
  search_details : any = []
  //user_search_details: any = [];
  supplier_screen_details: any = [];
  formData: any = [];

  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  constructor(private vernostService: VernostServiceService, private csvupload: CsvUploadService, private router: Router) { 
    
  }

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArray_user = {
      funId: this.fid,
      roleID: this.roleID
    };
    this.vernostService.checkFunAccess(rollArray_user).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.user_screen_details = {
      USER_FIRSTNAME: "",
      USER_LASTNAME: "",
      USER_EMAIL: "",
      USER_ADDRESS: "",
      USER_MOBILE: "",
      ROLE_ID: ""
    };
    this.search_details = {
      USER_FIRSTNAME : "",
      USER_EMAIL :""
    }
    this.addCombo(this.childtables[0], this.filters[0]);
    this.addCheckbox(this.childtables[0]);
    this.user_screen_details = {
      USER_FIRSTNAME: "",
      USER_LASTNAME: "",
      USER_EMAIL: "",
      USER_ADDRESS: "",
      USER_MOBILE: "",
      ROLE_ID: ""
    };
    this.user_search_details = {
      USER_FIRSTNAME: "",
      USER_LASTNAME: "",
      USER_EMAIL: ""
    };

    this.showList = false;
  }
  ngAfterViewInit() {
    var rollArray_user_1 = {
      funId: this.fid,
      roleID: this.roleID
    };
    this.vernostService.checkFunAccess(rollArray_user_1).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
  }
  checkAproval() {
    var dbField = [this.APPROVAL_STATUS];
    var array_user = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(array_user).subscribe(response => {
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  aproveReject(status) {
    var dbField_user = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY
    ];
    var formData = [status, this.aprove_details.APPROVAL_REMARKS, this.uid];
    var array_user = {
      dbField: dbField_user,
      parent_table: this.parent_table,
      formData: formData,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
 
    this.vernostService.aproveReject(array_user).subscribe(response => {
      this.searchForm();
    });
  }


  addCheckbox(childtable) {
    var array = {
      childtable: childtable
    };
    this.vernostService.getComboData(array).subscribe(response => {
      if (response[0].status == this.childtables[0]) {
        this.checkbox_details = response[0].result;
      }
    });
  }

  checkCheckBox(event) {
    if (event.target.checked) {
      var data = event.target.value;
      this.checkboxId.push(data);
    }
  }
  addForm() {
    this.userFNameExceedLength1 = false;
    this.userFNameNotAlphabet1 = false;
    this.invalidMail1 = false;
    document.getElementById("errs").innerHTML = "";
    this.userFNameMinLength = false;
    this.userFNameExceedLength = false;
    this.userFNameNotAlphabet = false;
    this.userLNameMinLength = false;
    this.userLNameExceedLength = false;
    this.userLNameNotAlphabet = false;
    this.userMobileMinLength = false;
    this.userMobileExceedLength = false;
    this.userMobileNotNumber = false;
    this.userAddressMinLength = false;
    this.userAddressExceedLength = false;
    this.userEmail = false;
    this.user_screen_details = {
      USER_FIRSTNAME: "", USER_LASTNAME: "", USER_EMAIL: "", USER_ADDRESS: "", USER_MOBILE: "", ROLE_ID: ""
    };
    this.Parent_result_ID = "";
    this.actionmode = "Add";
    this.showList = false;
  }
  openfileDialog() {
    document.getElementById("fileLoader").click();
  }
  fileChangeListener($event): void {
    this.csvupload.fileChangeListen($event, this.parent_table);
  }
  searchForm() {

    document.getElementById("errs").innerHTML = "";

    this.userFNameMinLength = false;

    this.userFNameExceedLength = false;

    this.userFNameNotAlphabet = false;

    this.userLNameMinLength = false;

    this.userLNameExceedLength = false;

    this.userLNameNotAlphabet = false;

    this.userMobileMinLength = false;

    this.userMobileExceedLength = false;

    this.userMobileNotNumber = false;

    this.userAddressMinLength = false;

    this.userAddressExceedLength = false;

    this.userEmail = false;

    this.user_screen_details = {
      USER_FIRSTNAME: "",
      USER_LASTNAME: "",
      USER_EMAIL: "",
      USER_ADDRESS: "",
      USER_MOBILE: "",
      ROLE_ID: ""
    };

    this.user_search_details = {
      USER_FIRSTNAME: "",
      USER_LASTNAME: "",
      USER_EMAIL: ""
    };
    this.searchresult = false;
    this.actionmode = "Search";
  }

  showFormData(formData, toggle) {
    this.Parent_result_ID = formData;
    var data;
    var array = {
      parent_table: this.parent_table,
      dbFields: [this.dbField , this.USER_STATUS ],
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    //console.log("all array=============", array);
    this.vernostService.getData(array).subscribe(response => {
      //console.log("response======" + JSON.stringify(response));
      this.user_screen_details = {
        USER_FIRSTNAME: response[0].result[0].USER_FIRSTNAME,
        USER_LASTNAME: response[0].result[0].USER_LASTNAME,
        USER_EMAIL: response[0].result[0].USER_EMAIL,
        USER_ADDRESS: response[0].result[0].USER_ADDRESS,
        USER_MOBILE: response[0].result[0].USER_MOBILE,
        ROLE_ID: response[0].result[0].ROLE_ID
      };
      this.serachTableInfo = response[0].result;
      var parent_table = "mst_user";
      var childtables = ["mst_role"];
      var datalike = ["ROLE_ID"];
      var dbFields = ["ROLE_NAME"];
      var findData = [this.user_screen_details.ROLE_ID];
     
      if (toggle == "1") {
        data = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };

        this.vernostService.searchRecordById(data).subscribe(searchresponse => {
          var f1 = searchresponse[0];
          this.roleName = f1[0].ROLE_NAME;
        });

        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        data = {
          parent_table: parent_table,
          childtables: childtables,
          datalike: datalike,
          dbFields: dbFields,
          findData: findData
        };

        this.vernostService.searchRecordById(data).subscribe(searchDataResponse => {
          var f1 = searchDataResponse[0];
          this.roleName = f1[0].ROLE_NAME;
        });

        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        this.showList = false;
        this.actionmode = "Edit";
      }
    });
  }

  addCombo(childtable, dbField) {
    var array = {
      childtable: childtable,
      dbField: dbField
    };
    // console.log(array,"jgjhg");

    this.vernostService.getComboData(array).subscribe(response => {
      this.combo_details1 = response;
    });
  }

  sendSms(mobileNO) {
    var array = {
      mobile_no: mobileNO
    };
    this.vernostService.sendSms(array).subscribe(response => {
      this.searchForm();
    });
  }

  submitdata() {
    this.offSubmit = false;
    var USER_FIRSTNAME = this.user_screen_details.USER_FIRSTNAME;
    var USER_LASTNAME = this.user_screen_details.USER_LASTNAME;
    var USER_EMAIL = this.user_screen_details.USER_EMAIL;
    var USER_ADDRESS = this.user_screen_details.USER_ADDRESS;
    var USER_MOBILE = this.user_screen_details.USER_MOBILE;
    var ROLE_ID = this.user_screen_details.ROLE_ID;
    this.formData = [
      USER_FIRSTNAME,
      USER_LASTNAME,
      USER_EMAIL,
      USER_ADDRESS,
      USER_MOBILE,
      ROLE_ID
    ];
    //console.log(JSON.stringify(this.formData));
    if (
      USER_FIRSTNAME != "" &&
      USER_LASTNAME != "" &&
      USER_EMAIL != "" &&
      USER_ADDRESS != "" &&
      USER_MOBILE != "" &&
      ROLE_ID != ""
    ) {
      if (this.Parent_result_ID != "") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbField,
          parent_table_ID: this.parent_table_ID,
          formData: this.formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editData(array).subscribe(response => {
          // //console.log(JSON.stringify(response[0].status));
          //       this.searchForm();

          document.getElementById("errs").innerHTML =
            "Record updated successfully";
          this.loader = false;
           setTimeout(()=>{
            this.actionmode = 'Search'
            this.user_screen_details.USER_FIRSTNAME = this.search_details.USER_FIRSTNAME
            this.user_screen_details.usr_email_id = this.search_details.USER_EMAIL
            this.searchData()
                document.getElementById("errs").innerHTML = "";
            },1000)
        });
      }

      if (this.Parent_result_ID == "") {
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          // formData: this.formData,
          USER_FIRSTNAME,
          USER_LASTNAME,
          USER_EMAIL,
          USER_ADDRESS,
          USER_MOBILE,
          ROLE_ID,
          parent_table_ID: this.parent_table_ID,
          checkboxId: this.checkboxId,
          USER_ID: this.uid,
          PAGENAME: "USER"
        };
        this.vernostService.insertUserData(Data).subscribe(response => {
          //console.log(JSON.stringify(response[0].message));
          if (JSON.stringify(response[0].status == "success")) {
            
            this.showFormData(response[0].addinfo, 3);
          }
          if (JSON.stringify(response[0].status == "failed")) {
            // this.showFormData(response[0].addinfo, 3);
          }
          this.loader = false;
        });
      }
    } else {
      //console.log("please fill all record");
      document.getElementById("errs").innerHTML = " please Fill all Data";
      setTimeout(function () {
        document.getElementById("errs").innerHTML = "";
      }, 1000);
    }
  }

  deleteUser(){

     var USER_EMAIL = this.user_screen_details.USER_EMAIL;

     const data =  {
      USER_EMAIL:USER_EMAIL
     }

     this.vernostService.deleteUser(data).subscribe(response => {
      if(response.status){
          document.getElementById("errs").innerHTML =
            "Record updated successfully";
          this.loader = false;
          setTimeout(()=>{
            this.actionmode = 'Search'
            this.user_screen_details.USER_FIRSTNAME = this.search_details.USER_FIRSTNAME
            this.user_screen_details.usr_email_id = this.search_details.USER_EMAIL
            this.searchData()
                document.getElementById("errs").innerHTML = "";
            },1000)
      }
      else{
        if(response.message == 'NO RECORD FOUND'){
          document.getElementById("errs").innerHTML =
            "NO RECORD FOUND";
          this.loader = false;
        }
        else{
          document.getElementById("errs").innerHTML =
            "Something Went Wrong";
          this.loader = false;
        }
      }
        
        });
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;
    var field1 = this.user_screen_details.USER_FIRSTNAME;
    var field2 = this.user_screen_details.usr_email_id;

    this.search_details.USER_FIRSTNAME = field1 ;
    this.search_details.USER_EMAIL = field2
    if ((field1 == "" || field1 == undefined) && (field2 == "" || field2 == undefined)) {
      this.loader = false;
      document.getElementById("errs").innerHTML = "Please apply filter to search";
      this.searchresult = false;
    } 
    else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(field1);
        searchColumn.push("USER_FIRSTNAME");
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(field2);
        searchColumn.push("USER_EMAIL");
      }
      var Data_user = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      this.vernostService.searchRecord(Data_user).subscribe(response => {
        if (response.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;
          this.searchresult = true;
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function () {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  searchData1() {
    this.searchlist = false;
    this.loader = true;
    //console.log("this.supplier_screen_details", this.user_screen_details);
    var field1 = this.user_screen_details.USER_FIRSTNAME;
    var field2 = this.user_screen_details.USER_EMAIL;

    if (field2 != "") {
      this.searchitem = field2;
      this.searchColumn = this.USER_EMAIL;
    } else {
      this.searchitem = field1;
      this.searchColumn = this.USER_FIRSTNAME;
    }

    //console.log(this.parent_table);
    var Data = {
      parent_table: this.parent_table,
      dbFields: this.searchColumn,
      searchData: this.searchitem,
      filters: this.filters,
      childtables: this.childtables
    };
    this.vernostService.searchRecord(Data).subscribe(response => {
      this.loader = false;
      //console.log(JSON.stringify(response));
      this.serachtabledata = response;

      if (response.length > 0) {
        this.searchresult = true;
        this.serachtabledata = response;
        document.getElementById("errs").innerHTML = "";
      } else {
        this.searchresult = false;
        document.getElementById("errs").innerHTML = "Record not found";
      }
    });
  }

  checkUserFName(data) {
    this.validateUserFNames(data);
  }
  checkUserFName1(data) {
    if (data.length == 0) {
      this.userFNameNotAlphabet1 = false;
      this.userFNameMinLength1 = false;
    } else {
      if (data.length == "") {
        this.userFNameNotAlphabet1 = false;
      }
      if (data.length < 1) {
        this.userFNameMinLength1 = true;
        // this.userFNameNotAlphabet = false;
      } else {
        this.userFNameMinLength1 = false;
      }
    }
  }

  validateUserFNames(data) {
    if (data.length == 0) {
      this.userFNameNotAlphabet = false;
      this.userFNameMinLength = false;
    } else {
      if (data.length == "") {
        this.userFNameNotAlphabet = false;
      }
      if (data.length < 1) {
        this.userFNameMinLength = true;
        // this.userFNameNotAlphabet = false;
      } else {
        this.userFNameMinLength = false;
      }
    }
  }
  checkUserFNameLength(data) {
    this.userFNameExceedLength = false;
    this.userFNameMinLength = false;
    this.userFNameNotAlphabet = false;
    //console.log(data);

    var regx = /^[A-Za-z\s]+$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.userFNameMinLength = false;
      this.userFNameExceedLength = false;
      this.userFNameNotAlphabet = false;
    } else {
      if (data.length > 50) {
        this.userFNameExceedLength = true;
        this.userFNameMinLength = false;
      } else {
        this.userFNameExceedLength = false;
      }
      if (!checkAlphabet) {
        this.userFNameNotAlphabet = true;
      } else {
        this.userFNameNotAlphabet = false;
      }
    }
  }

  checkUserFNameLength1(data) {
    this.userFNameExceedLength1 = false;
    this.userFNameMinLength1 = false;
    this.userFNameNotAlphabet1 = false;
    //console.log(data);

    var regx = /^[A-Za-z\s]+$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.userFNameMinLength1 = false;
      this.userFNameExceedLength1 = false;
      this.userFNameNotAlphabet1 = false;
    } else {
      if (data.length > 50) {
        this.userFNameExceedLength1 = true;
        this.userFNameMinLength1 = false;
      } else {
        this.userFNameExceedLength1 = false;
      }
      if (!checkAlphabet) {
        this.userFNameNotAlphabet1 = true;
      } else {
        this.userFNameNotAlphabet1 = false;
      }
    }
  }

  checkUserLName(data) {
    this.validateUserLNames(data);
  }
  validateUserLNames(data) {
    if (data.length == 0) {
      this.userLNameMinLength = false;
    } else {
      if (data.length < 1) {
        this.userLNameMinLength = true;
        // this.userLNameNotAlphabet = false;
      } else {
        this.userLNameMinLength = false;
      }
    }
  }
  checkUserLNameLength(data) {
    this.userLNameExceedLength = false;
    this.userLNameMinLength = false;
    this.userLNameNotAlphabet = false;
    //console.log(data);
    document.getElementById("errs").innerHTML = "";
    var regx = /^[A-Za-z\s]+$/;
    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.userLNameExceedLength = false;
      this.userLNameNotAlphabet = false;
      this.userLNameMinLength = false;
    } else {
      if (data.length > 50) {
        this.userLNameExceedLength = true;
        this.userLNameMinLength = false;
      } else {
        this.userLNameExceedLength = false;
      }
      if (!checkAlphabet) {
        this.userLNameNotAlphabet = true;
      } else {
        this.userLNameNotAlphabet = false;
      }
    }
  }

  validateMobile(data) {
    if (data.length == 0) {
      this.userMobileMinLength = false;
    } else {
      if (data.length < 10) {
        this.userMobileMinLength = true;
        // this.userMobileNotNumber = false;
      } else {
        this.userMobileMinLength = false;
      }
    }
  }
  checkMobileLength(data) {
    this.invalidMobile = false;
    this.userMobileExceedLength = false;
    this.userMobileMinLength = false;
    this.userMobileNotNumber = false;
    //console.log(data);

    var regx = /^[0-9]+$/;

    var checkAlphabet = regx.test(data);
    if (data.length == 0) {
      this.userMobileExceedLength = false;
      this.userMobileNotNumber = false;
      this.userMobileMinLength = false;
    } else {
      if (data.length > 10) {
        this.userMobileExceedLength = true;
        this.userMobileMinLength = false;
      } else {
        this.userMobileExceedLength = false;
      }
      if (!checkAlphabet) {
        this.userMobileNotNumber = true;
      } else {
        this.userMobileNotNumber = false;
      }
    }
  }

  checkUserAddress(data) {
    this.validateAddress(data);
  }
  validateAddress(data) {
    if (data.length == 0) {
      this.userAddressMinLength = false;
    } else {
      if (data.length < 2) {
        this.userAddressMinLength = true;
      } else {
        this.userAddressMinLength = false;
      }
    }
  }
  checkAddressLength(data) {
    this.userAddressExceedLength = false;
    this.userAddressMinLength = false;
    //console.log(data);
    if (data.length == 0) {
      this.userAddressMinLength = false;
      this.userAddressExceedLength = false;
    } else {
      if (data.length > 250) {
        this.userAddressExceedLength = true;
        this.userAddressMinLength = false;
      } else {
        this.userAddressExceedLength = false;
      }
    }
  }

  checkEmailNames(data) {
    this.checkNames();
    this.checkEmailAddress(data);
  }
  checkEmailAddress(data) {
    if (data.length == 0) {
      this.userEmail = false;
    } else {
      if (data.length == "") {
        this.userEmail = false;
      }
      this.userEmail = false;
      //console.log(data);

      var regx = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      var checkAlphabet = regx.test(data);

      if (!checkAlphabet) {
        this.userEmail = true;
      } else {
        this.userEmail = false;
      }
    }
  }

  checkEmailNames1(data) {
    if (data.length == 0) {
      this.userEmail1 = false;
    } else {
      if (data.length == "") {
        this.userEmail1 = false;
      }
      this.userEmail1 = false;
      //console.log(data);

      var regx = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      var checkAlphabet = regx.test(data);

      if (!checkAlphabet) {
        this.userEmail1 = true;
      } else {
        this.userEmail1 = false;
      }
    }
  }

  cleardiv() {
    document.getElementById("errs").innerHTML = "";
  }

  checkNames() {
    if (
      this.user_screen_details.USER_EMAIL != undefined &&
      this.user_screen_details.USER_EMAIL != ""
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "USER_EMAIL",
          dbFieldName: this.user_screen_details.USER_EMAIL,
          parent_table: this.parent_table
        };

        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist = true;
            this.loader = false;
          }
        });
      } else {
        this.onEdit_checkName();
      }
    }
  }

  submitData1() {
    var USER_FIRSTNAME = this.user_screen_details.USER_FIRSTNAME;
    var USER_LASTNAME = this.user_screen_details.USER_LASTNAME;
    var USER_EMAIL = this.user_screen_details.USER_EMAIL;
    var USER_ADDRESS = this.user_screen_details.USER_ADDRESS;
    var USER_MOBILE = this.user_screen_details.USER_MOBILE;
    var ROLE_ID = this.user_screen_details.ROLE_ID;
    if (
      USER_FIRSTNAME != "" &&
      USER_LASTNAME != "" &&
      USER_EMAIL != "" &&
      USER_ADDRESS != "" &&
      USER_MOBILE != "" &&
      ROLE_ID != ""
    ) {
      this.offSubmit = true;
      this.loader = true;
      if (this.actionmode != "Edit") {
        this.checkNames();
      } else {
        if (this.actionmode == "Edit") {
          this.onEdit_checkName();
        }
      }
    } else {
      document.getElementById("errs").innerHTML = "Please fill all Data";
    }
  }

  onEdit_checkName() {
    if (this.actionmode == "Edit") {
      var code = this.Parent_result_ID;
      var name = this.user_screen_details.USER_EMAIL;
      var table = this.parent_table;
      var column = "USER_EMAIL";
      var column1 = "USER_ID";
      let array = {
        code: code,
        name: name,
        table: table,
        column: column,
        column1: column1
      };
      this.vernostService.checkRecordName(array).subscribe(data => {
        //console.log("here=", data);
        if (data[0].status == "success") {
          this.nameExist = true;
        } else {
          this.loader = false;
          this.nameExist = false;
          if (this.offSubmit) {
            this.submitdata();
          }
        }
      });
    }
  }
}
